import template from './home.html';

export function HomeViewModel() {
}

// The default export returns the component details object to register with KO
export default { viewModel: HomeViewModel, template: template };
